<template>
  <div :style="themeStyle" style="min-height: 100vh;">
     <v-overlay :value="loading">
     <v-progress-circular
        indeterminate
        size="64"
        color="#F3E9DD"
      ></v-progress-circular>
    </v-overlay>
    <!-- <v-overlay :value="loading" absolute opacity="0.6">
      <v-sheet class="d-flex flex-column align-center pa-6" elevation="3" style="min-width:200px;border-radius:8px">
        <v-progress-circular indeterminate :size="48" :color="levelById && levelById.color ? levelById.color : 'primary'"></v-progress-circular>
        <div class="mt-3" style="font-weight:500">Checking theme colors...</div>
      </v-sheet>
    </v-overlay> -->
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" >
      <v-card v-if="dialog && use">
        <v-toolbar :color="HEXToVBColorLMG(levelById.color)">
          <v-btn icon dark @click="closeUseReward">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Use Reward</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader>{{ $t("message.showQrcodeReward") }}</v-subheader>
          <v-divider></v-divider>
        </v-list>
        <v-row>
          <v-col class="text-center ma-0 pa-0 font24" :style="{ 'color': $CUSTOMMainTextColor }">
            {{ use.rewardCode }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <qrcode-usecode :shopId="use.shopId" :rewardId="use.rewardId" :rewardCode="use.rewardCode"
              :lineUserId="profile.userId"></qrcode-usecode>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="text-center font20" :style="{ 'color': $CUSTOMMainTextColor }">
            {{ $t("message.rewardDetail") }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="d-flex flex-column justify-space-between align-center"><v-img :src="use.pictureUrl"
              max-width="150"></v-img></v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-row class="font16 bold " :style="{ 'color': $CUSTOMMainTextColor }">
              <v-col class="pl-0 pt-2 pb-3" :class="{ bold: !isTargetShop }">{{ use.name }}</v-col>
            </v-row>
            <v-row class="font14 icon2">
              <v-col class="pl-0 pt-0 pb-3">{{ $t("message.useBefor") }}
                <span class="icon1" :style="{ 'color': $CUSTOMMainTextColor }">{{ use.endDate }}</span></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRewardhistory" fullscreen hide-overlay transition="dialog-bottom-transition"
      style="border-radius: 10 ! important">
      <v-card>
        <v-toolbar :color="levelById.color" flat tile>
          <v-btn icon @click="dialogRewardhistory = false">
            <v-icon :color="HEXToVBColorLMG(levelById.color) ">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <div :style="'color:' + (HEXToVBColorLMG(levelById.color)) + '!important'">{{ $t("message.rewardHistory") }}
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list three-line subheader>
          <v-list-item v-for="(item, i) in rewardHistory" :key="i" class="pl-0 pr-0">
            <v-list-item-content style="border-bottom: solid #e5e0e0;">
              <v-col cols="4" style="padding-top: 10px" align="center">
                <img v-if="$isTargetShop()" :src="item.pictureUrl" style="
                    width: 95px;
                    height: 95px;
                    border-radius: 0px;
                    border-style: solid;
                    border-color: #eeee;
                  " class="link" />
                             <img v-else :src="item.pictureUrl" style="
                    width: 95px;
                    height: 95px;
                    border-radius: 20px;
                    border-style: solid;
                    border-color: #eeee;
                  " class="link" />
              </v-col>
              <v-col cols="8" class="pl-0 pr-0">
                <div class="font16 bold mt-1">
                  <v-col class="pa-0 mb-1" :class="{ bold: !isTargetShop }">{{ item.name }}</v-col>
                  <v-col class="pa-0 mb-1" v-if="item.supply === 'จัดส่ง'">{{ $t("message.type") }}:
                    <v-icon>mdi-cube-send</v-icon>
                    {{ item.supply }}</v-col>
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง'">{{ $t("message.deliveryLocation") }}: {{
                    item.houseNumber }}, ต.{{
                      item.subDistrict
                    }}. อ.{{ item.district }}. จ.{{ item.provinces }}.
                    {{ item.postalCode }}</v-col>
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง' && item.parcelNumber">{{
                    $t("message.parcelNumber") }}: {{ item.parcelNumber }}
                  </v-col>
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง' && item.Transport">{{
                    $t("message.transportationService") }}: {{ item.Transport }}
                  </v-col>
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'link_code' && item.parcelNumber !== null">{{
                    $t("message.type") }}:
                    <v-icon>mdi-barcode-scan</v-icon>
                    {{ $t("message.linkcode") }}</v-col>
                  <v-col class="pa-0 mb-2" v-if="
                    item.supply === 'link_code' &&
                    !item.rewardCode.startsWith('http') && item.rewardCode.search('/') === -1
                  ">
                    <v-text-field v-model="item.rewardCode" :append-icon="item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      " ref="textToCopy" outlined style="width: 220px" dense hide-details
                      @click:append="copyText()"></v-text-field>
                  </v-col>
                  <v-col class="pa-0 mb-2" v-if="
                    item.supply === 'link_code' &&
                    !item.rewardCode.startsWith('http') && item.rewardCode.search('/') !== -1
                  ">
                    <v-text-field v-model="item.rewardCode.split('/')[0]" :append-icon="item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      " ref="textToCopy" outlined style="width: 220px" dense hide-details
                      @click:append="copyText()"></v-text-field>
                    <v-text-field v-model="item.rewardCode.split('/')[1]" :append-icon="item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      " ref="textToCopy" outlined style="width: 220px" dense hide-details
                      @click:append="copyText()"></v-text-field>
                  </v-col>
                  <!-- <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      !item.rewardCode.startsWith('http')
                    "
                    ><v-btn color="primary" fab x-small dark @click="copyText"
                      ><v-icon>mdi-content-copy</v-icon></v-btn
                    ></v-col> -->
                  <v-col class="pa-0 mb-2" v-if="
                    item.supply === 'link_code' &&
                    item.rewardCode.startsWith('http')
                  ">
                    <a :href="item.rewardCode">*{{ item.rewardCode }}</a>
                  </v-col>
                  <v-col class="pa-0 mb-2" v-if="
                    item.supply === 'link_code' &&
                    item.rewardCode.startsWith('http')
                  ">
                    {{ $t("message.presslink") }}
                  </v-col>
                  <v-col class="pa-0 mb-1" v-if="item.supply === 'รับหน้าร้าน' || item.supply === null">
                    <v-icon class="pb-1">mdi-store</v-icon>{{ item.shopId === 'U2ad4ca7a5c84fbe7358b56f54af919fa' ?
                      'รับที่สำนักงานโครงการ' : $t("message.ReceiveAtStore") }}</v-col>
                  <v-col class="pl-0 pt-0 pb-1 font16 icon2 mb-1">{{ $t("message.redeemDate") }}: {{
                    format_date_thai(item.useDate.split(' ').slice(0, -1)) }}</v-col>
                  <v-col class="pa-0 icon2 mt-1" v-if="
                    item.supply === 'จัดส่ง' && item.sendStatus === 'รอจัดส่ง'
                  "><v-chip small color="red" dark> {{ $t("message.waitDelivery") }}</v-chip></v-col>
                  <v-col class="pa-0 icon2 mt-1" v-if="
                    item.supply === 'จัดส่ง' && item.sendStatus !== 'รอจัดส่ง'
                  "><v-chip small color="green" dark>{{ $t("message.alreadyShip") }}</v-chip></v-col>
                  <v-col class="pa-0 mt-1" v-if="item.supply === 'รับหน้าร้าน' || item.supply === null"><v-chip small
                      color="green" dark>{{ $t("message.received") }}</v-chip></v-col>
                  <v-col class="pa-0 mt-1" v-if="item.supply === 'link_code'"><v-chip small color="green" dark>{{
                    $t("message.received") }}</v-chip></v-col>
                </div>
              </v-col>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <v-row no-gutters style="background: linear-gradient(146deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(140, 140, 140, 1) 100%);">
      <v-dialog v-model="dialogPolicy" width="500">
        <v-card>
          <v-card-title class="bold headline2">
            {{ $t("message.policy") }}
          </v-card-title>

          <v-card-text class="pa-5">
            <div class="mb-3">
              <div style="display: flex">
                <v-checkbox hide-details v-model="checkTerm1" @click.stop :color="$bgColor">
                </v-checkbox>
                <template>
                  <div @click="dialogTerm1 = true" style="align-self: center;padding-top: 15px;">
                    {{ $t("message.condition") }}
                    <template>
                      <a href="#" @click="openPrivacyNotice">
                        {{ $t("message.policy") }}
                      </a>
                    </template>
                  </div>
                </template>
              </div>
              <v-checkbox hide-details v-model="checkTerm2" @click.stop :color="$bgColor">
                <template v-slot:label>
                  <div style="align-self: center;padding-top: 15px;font-size: 14px;" >
                    {{ $t("message.condition2") }} {{ shopname }}
                  </div>
                </template>
              </v-checkbox>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="levelById.color" @click.stop="upDatePDPA(), dialogPolicy = false">
              <div :style="'color:' + HEXToVBColorLMG(levelById.color)">I accept</div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-col>
        <span class="pt-5" style="position: absolute; top: 15px; right: 20px; z-index: 10" :class="$isTargetShop? '' : 'bold'">
          <span v-if="$isTargetShop && levelById && levelById.color === '#484848FF' && level && level.name" class="ma-5 pt-5"  :style="'color:' + '#FFF'">
          {{ level.name }}
          <img v-if="this.checkpushCustom()"
            :src="HEXTHEMELMG(levelById.color) ? $images.dimondChubb : $isTargetShop ? $images.dimondChubb : $images.pointWhite"
            class="ms-1"
            width="15"
            :style="$isTargetShop ? imgFilterComputed ? 'filter: brightness(0) invert(1);' : '' : ''"
            />
       </span>
          <span v-else-if="$isTargetShop && levelById && levelById.color === '#000ECCFF' && level && level.name" class="ma-5 pt-5"  :style="'color:' + '#FFF'">
          {{ level.name }}
          <img v-if="this.checkpushCustom()"
            :src="HEXTHEMELMG(levelById.color) ? $images.dimondChubb : $isTargetShop ? $images.dimondChubb : $images.pointWhite"
            class="ms-1"
            width="15"
            :style="$isTargetShop ? imgFilterComputed ? 'filter: brightness(0) invert(1);' : '' : ''"
            />
       </span>
          <span v-else-if="$isTargetShop && levelById && levelById.color !== '#484848FF' && levelById.color !== '#000ECCFF' && level && level.name" class="ma-5 pt-5"  :style="'color:' + '#000'">
          {{ level.name }}
          <img v-if="this.checkpushCustom()"
            :src="HEXTHEMELMG(levelById.color) ? $images.dimondChubb : $isTargetShop ? $images.dimondChubb : $images.pointWhite"
            class="ms-1"
            width="15"
            />
       </span>
            <v-chip v-else-if="levelById && level && level.name" class="ma-2" :color="levelById.color" style="font-size:12px"
          :style="'color:' + textColorChubComputed">
          <span :style="'color:' + textColorChubComputed + '!important'">{{ level.name }} </span>
          <img v-if="this.checkpushCustom()"
            :src="HEXTHEMELMG(levelById.color) ? $images.dimondChubb : $isTargetShop ? $images.dimondChubb : $images.pointWhite"
            class="ms-1"
            width="15"
            :style="$isTargetShop ? imgFilterComputed ? 'filter: brightness(0) invert(1);' : '' : ''"
            />

            </v-chip>
        </span>
        <div class="pa-3">
          <div :style="{ backgroundImage: 'linear-gradient(291deg,' + levelById.color + ' 0%,' + levelById.color + ' 100%)' }">
            <v-fade-transition mode="out-in">
              <v-img v-if="level && level.pictureUrl" :src="level.pictureUrl" max-height="220">
                <div style="
                    position: absolute;
                    bottom: 110px;
                    left: 20px;
                    display: flex;
                    align-items: center;
                  ">
                  <p class="text-bold-mb-10" style="font-size: 24px;" :style="{ '--color-text':isTargetShop ? HEXToVBColorLMGCard(levelById.color): $CUSTOMMainTextColor }" :class="{ bold: !isTargetShop }" v-if="nextlevel">
                                {{ formatNumber(member.collectPoint) }}/
                              </p>
                  <p class="text-bold-mb-10" style="font-size: 24px;" :style="{ '--color-text': isTargetShop ? HEXToVBColorLMGCard(levelById.color): $CUSTOMMainTextColor }" :class="{ bold: !isTargetShop }" v-if="!nextlevel">
                                {{ formatNumber(member.collectPoint) }}
                              </p>
                  <p v-if="nextlevel !== null" style="padding-top: 8px;" class="text-bold-mb-10" :style="{ '--color-text': isTargetShop ? HEXToVBColorLMGCard(levelById.color): $CUSTOMMainTextColor }" :class="{ bold: !isTargetShop }">
                                {{ point === 0 ? '' : formatNumber(point) }}
                              </p>
                  <img v-if="profile && profile.pictureUrl && !isTargetShop" style="
                      border-color: black;
                      height: 30px;
                      margin-left:5px;
                      padding-bottom: 9px;
                    " alt="Avatar" :src="require('@/assets/coin.png')" />
                  <p style="
                                  position: absolute;
                                  width: 300px;
                                  bottom: -35px;
                                  text-align: left;
                                  font-size: 13px;
                                " v-if="!nextlevel" class="text-bold-mb-10" :class="{ bold: !isTargetShop }" :style="{ '--color-text': isTargetShop ? HEXToVBColorLMGCard(levelById.color):$CUSTOMMainTextColor }">
                                {{ $t("message.memberHightLevel") }}
                              </p>
                  <p style="
                                  position: absolute;
                                  width: 300px;
                                  bottom: -35px;
                                  text-align: left;
                                  font-size: 13px;
                                " v-if="nextlevel" class="text-bold-mb-10" :class="{ bold: !isTargetShop }" :style="{ '--color-text': isTargetShop ? HEXToVBColorLMGCard(levelById.color) :$CUSTOMMainTextColor }">
                                {{ $t("message.collectMore") }}
                                {{ formatNumber(point - member.collectPoint) }} {{ $t("message.point") }} ( {{ parseInt(moneyResult) ===
                                  0 ? ''
                                : moneyResult}} ) {{ $t("message.thb") }}
                              </p>
                  <p style="
                                  position: absolute;
                                  width: 300px;
                                  bottom: -50px;
                                  text-align: left;
                                  font-size: 13px;
                                " v-if="nextlevel" class="text-bold-mb-10" :class="{ bold: !isTargetShop }" :style="{ '--color-text': isTargetShop ? HEXToVBColorLMGCard(levelById.color) :$CUSTOMMainTextColor }">
                                {{ $t("message.levelUp") }} {{ nextlevel.name }}
                              </p>
                </div>
                <div class="test">
                  <v-progress-linear style="position: absolute; bottom: 110px" height="5" rounded
                    background-color="#EEEEEE" color="#000" :value="valueInprogress">
                  </v-progress-linear>
                </div>
                <div style="
                    position: absolute;
                    bottom: -19px;
                    width: 100%;
                    height: 32%;
                    margin-bottom: 0;
                    right:-8px;
                  " @click="$router.push('/C/level')">
                  <div :style="{
                    'color': $isTargetShop && levelById.color !== '#484848FF' && levelById.color !== '#000ECCFF' ? '#000' : textColorChubComputed + ' !important',
                    'margin-bottom': '0',
                    'margin-top': '7px',
                    'position': 'absolute',
                    'left': '10px',
                    'font-weight': '100',
                    'font-size': '12px',
                  }">
                    {{ $t("message.privilegeDetail") }}
                  </div>
                  <v-icon :style="{
                    'color': $isTargetShop && levelById.color !== '#484848FF' && levelById.color !== '#000ECCFF' ? '#000' :  textColorChubComputed + ' !important',
                    'margin-top': '4px',
                    'position': 'absolute',
                    'right': '20px',
                    'margin-top': '7px',
                  }">mdi-chevron-right</v-icon>
                </div>
              </v-img>
            </v-fade-transition>
        </div>
        </div>
      </v-col>
    </v-row>
    <div class="pa-3 pt-6 pb-0">
      <v-sheet class="pa-3" style="margin-bottom: 15px;border-radius: 0px" elevation="1">
        <v-row>
          <v-col style="text-align: center;font-weight: bold;padding-bottom: 0px;"></v-col>
        </v-row>
        <div>
          <v-row>
            <v-col cols="7" class="pt-2 pb-0 pr-0">
              {{ $t("message.expirePoint") }} <strong :style="{ 'color': $CUSTOMMainTextColor }">{{ new
                Date().getFullYear()
                }}</strong>
            </v-col>
            <v-col cols="5" align="right" class="pt-2 pb-0 pl-0 pr-0" style="padding-right: 17px !important">
              <strong :style="{ 'color': $CUSTOMMainTextColor }">{{ formatNumber(AllExpireCoinThisYear) }}</strong> {{
                $t("message.point")
              }}
            </v-col>
            <v-col cols="12">
              <Dialog :month="month" />
            </v-col>
          </v-row>
          <v-divider color="#000"></v-divider>
          <v-row>
            <v-col cols="7" class="pt-2 pb-0 pr-0">
              {{ $t("message.expirePoint") }} <strong :style="{ 'color': $CUSTOMMainTextColor }">{{ new
                Date().getFullYear() + 1 }}</strong>
            </v-col>
            <v-col cols="5" align="right" class="pt-2 pb-0 pl-0 pr-0" style="padding-right: 17px !important">
              <strong :style="{ 'color': $CUSTOMMainTextColor }">{{ formatNumber(AllExpireCoinNextYear) }}</strong> {{
                $t("message.point")
              }}
            </v-col>
            <v-col cols="12" class="pb-4">
              <Dialog1 :month1="month1" ref="modal1" />
            </v-col>
          </v-row>
        </div>
      </v-sheet>
      <EnglishMunMun v-if="shopId === 'Ub7cbc419244731cdd682354dd0e57cef'" :allBookings="allBookings" />
    </div>

    <div class="pa-3 pt-4">
      <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: stretch; gap: 10px;">
        <!-- {{isTargetShop ? HEXToVBColorLMG(levelById.color): $CUSTOMMainTextColor}} -->
        <!-- {{HEXToVBColorLMG(levelById.color)}}
        {{$CUSTOMMainTextColor}} -->
        <!-- {{levelById.color}} -->
        <!-- การ์ดที่ 1 -->
        <div @click="$router.push('/C/NewMyReward').catch(() => { })" class="menu-card" :style="cardBgStyle">
          <div style="flex-grow: 1;">
            <img v-if="imgFilterComputed"  style="border-color: white; height: 40px; margin-bottom: 6px; filter: brightness(0) invert(1);" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.myReward : $images.ChubbGift" />
            <img v-else style="border-color: white; height: 40px; margin-bottom: 6px;" alt="Avatar"
              :src="  HEXTHEMELMG(levelById.color) ? $images.myReward : $images.ChubbGift" />
            <p class="mb-0" :style="'color:' + ( HEXToVBColorLMG(levelById.color))">{{ $t("message.myReward") }}</p>
          </div>

          <div class="text-caption target-shop-font"
             :style="'font-weight: 100;font-size:10px !important; color:' + ( HEXToVBColorLMG(levelById.color))">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + ( HEXToVBColorLMG(levelById.color))">
              mdi-chevron-right
            </v-icon>
                <!-- //// {{levelById.color}}\\\\ -->
          </div>
        </div>
        <!-- การ์ดที่ 2 -->
        <div v-if="formatNumber(myPackageCount) > 0" @click="$router.push('/C/MyPackage').catch(() => { })" class="menu-card" :style="cardBgStyle">
          <div style="flex-grow: 1;">
            <img v-if="imgFilterComputed" class="" style="border-color: white; height: 40px; margin-bottom: 6px;filter: brightness(0) invert(1);" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.myReward : $images.accountBlack" />
            <img v-else class="" style="border-color: white; height: 40px; margin-bottom: 6px;" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.myReward : $images.accountBlack" />
            <p class="mb-0" :style="'color:' + ( HEXToVBColorLMG(levelById.color))">{{ $t("message.privileges") }}</p>
          </div>
          <div class="text-caption"
            :style="'font-weight: 100;font-size:10px !important; color:' + ( HEXToVBColorLMG(levelById.color))">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + ( HEXToVBColorLMG(levelById.color))">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>

        <!-- การ์ดที่ 3 -->
        <div @click="$router.push('/C/tierBenefit').catch(() => { })" class="menu-card" :style="cardBgStyle">
          <div style="flex-grow: 1;">
            <img v-if="imgFilterComputed" style="border-color: white; height: 40px; margin-bottom: 6px;filter: brightness(0) invert(1);" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.allLevel : $images.allLevelWhite" />
            <img v-else style="border-color: white; height: 40px; margin-bottom: 6px;" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.allLevel : $images.allLevelWhite" />
            <p class="mb-0" :style="'color:' + ( HEXToVBColorLMG(levelById.color))">{{ $t("message.allLevel") }}</p>
          </div>
          <div class="text-caption"
            :style="'font-weight: 100;font-size:10px !important; color:' + ( HEXToVBColorLMG(levelById.color))">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + ( HEXToVBColorLMG(levelById.color))">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>

        <!-- การ์ดที่ 4 -->
        <div @click="$router.push('/C/transaction').catch(() => { })" class="menu-card" :style="cardBgStyle">
          <div style="flex-grow: 1;">
            <img v-if="imgFilterComputed" style="border-color: white; height: 40px; margin-bottom: 6px;filter: brightness(0) invert(1);" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.point : $images.pointHistoryWhite" />
            <img v-else style="border-color: white; height: 40px; margin-bottom: 6px;" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.point : $images.pointHistoryWhite" />
            <p class="mb-0" :style="'color:' + ( HEXToVBColorLMG(levelById.color))">{{ $t("message.pointHistory") }}</p>
          </div>
          <div class="text-caption"
            :style="'font-weight: 100;font-size:10px !important; color:' + ( HEXToVBColorLMG(levelById.color))">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + ( HEXToVBColorLMG(levelById.color))">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>

        <!-- การ์ดที่ 5 -->
        <div @click="dialogPolicy = true" class="menu-card" :style="cardBgStyle">
          <div style="flex-grow: 1;">
            <img v-if="imgFilterComputed" style="border-color: white; height: 40px; margin-bottom: 6px;filter: brightness(0) invert(1);" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.policy : $images.policyWhite" />
            <img v-else style="border-color: white; height: 40px; margin-bottom: 6px;" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.policy : $images.policyWhite" />
            <p class="mb-0" :style="'color:' + ( HEXToVBColorLMG(levelById.color))">{{ $t("message.policy") }}</p>
          </div>
          <div class="text-caption"
            :style="'font-weight: 100;font-size:10px !important; color:' + ( HEXToVBColorLMG(levelById.color))">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + ( HEXToVBColorLMG(levelById.color))">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>

        <!-- การ์ดที่ 6 -->
        <div @click="getHistory() === true" class="menu-card" :style="cardBgStyle">
          <div style="flex-grow: 1;">
            <img v-if="imgFilterComputed" style="border-color: white; height: 40px; margin-bottom: 6px;filter: brightness(0) invert(1);" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.pointHistory : $images.rewardHistoryWhite" />
            <img v-else style="border-color: white; height: 40px; margin-bottom: 6px;" alt="Avatar"
              :src="HEXTHEMELMG(levelById.color) ? $images.pointHistory : $images.rewardHistoryWhite" />
            <p class="mb-0" :style="'color:' + ( HEXToVBColorLMG(levelById.color))">{{ $t("message.rewardHistory") }}</p>
          </div>
          <div class="text-caption"
            :style="'font-weight: 100;font-size:10px !important; color:' + ( HEXToVBColorLMG(levelById.color))">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + ( HEXToVBColorLMG(levelById.color))">
              mdi-chevron-right
            </v-icon>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MenuItem from '../../MenuItem'
import MyRewards from '../../MyRewards'
import moment from 'moment'
import Dialog from './Expiredialog'
import Dialog1 from './Expiredialog1'
import axios from 'axios'
import EnglishMunMun from './EnglishMunMun'

export default {
  name: 'Card',
  components: {
    'menu-item': MenuItem,
    'my-rewards': MyRewards,
    Dialog,
    Dialog1,
    EnglishMunMun
  },
  computed: {
    result () {
      return this.calculateExchangeAmount(this.pointsReceived, this.totalPoints, this.exchangeRate)
    },
    isTargetShop () {
      try {
        return this.$isTargetShop()
      } catch (e) {
        return false
      }
    },
    themeStyle () {
      return { backgroundColor: '#fff' }
    },
    cardBgStyle () {
      if (this.$isTargetShop()) {
        return { backgroundColor: this.levelById.color }
      }
      return {
        backgroundImage: `linear-gradient(0deg, ${this.levelById.color} 0%, ${this.levelById.color} 100%)`
      }
    },
    textColorChubComputed () {
      if ((this.$isTargetShop()) && (this.levelById.color === '#484848FF' || this.levelById.color === '#000ECCFF' || this.levelById.color === '#808080FF' || this.levelById.color === '#FFA300FF')) {
        return '#fff'
      } else if (this.$isTargetShop() && this.levelById.color === '#B3B3B3') {
        return '#000'
      } else {
        return this.$CUSTOMMainTextColor
      }
    },

    imgFilterComputed () {
      if (this.$isTargetShop() && (this.levelById.color === '#484848FF' || this.levelById.color === '#000ECCFF' || this.levelById.color === '#808080FF' || this.levelById.color === '#B3B3B3FF' || this.levelById.color === '#FFA300FF')) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      use: 'some value',
      moneyResult: 0,
      pointsReceived: 0,
      totalPoints: 0,
      exchangeRate: 0,
      myPackageCount: 0,
      allBookings: null,
      noDataMessage: null,
      allDataLoaded: false,
      checkTerm1: null,
      checkTerm2: null,
      dialog: false,
      dialogPolicy: false,
      loading: false,
      member: null,
      level: null,
      levelById: { color: '#E0E0E0' },
      rewards: null,
      nextlevel: null,
      valueInprogress: null,
      point: 0,
      dialogRewardhistory: false,
      expire: null,
      expire1: null,
      AllExpireCoinThisYear: null,
      AllExpireCoinNextYear: null,
      myPackage: false,
      month: [
        { numMonth: '01', month: 'January', total: 0 },
        { numMonth: '02', month: 'February', total: 0 },
        { numMonth: '03', month: 'March', total: 0 },
        { numMonth: '04', month: 'April', total: 0 },
        { numMonth: '05', month: 'May', total: 0 },
        { numMonth: '06', month: 'June', total: 0 },
        { numMonth: '07', month: 'July', total: 0 },
        { numMonth: '08', month: 'August', total: 0 },
        { numMonth: '09', month: 'September', total: 0 },
        { numMonth: '10', month: 'October', total: 0 },
        { numMonth: '11', month: 'November', total: 0 },
        { numMonth: '12', month: 'December', total: 0 }
      ],
      month1: [
        { numMonth: '01', month: 'January', total: 0 },
        { numMonth: '02', month: 'February', total: 0 },
        { numMonth: '03', month: 'March', total: 0 },
        { numMonth: '04', month: 'April', total: 0 },
        { numMonth: '05', month: 'May', total: 0 },
        { numMonth: '06', month: 'June', total: 0 },
        { numMonth: '07', month: 'July', total: 0 },
        { numMonth: '08', month: 'August', total: 0 },
        { numMonth: '09', month: 'September', total: 0 },
        { numMonth: '10', month: 'October', total: 0 },
        { numMonth: '11', month: 'November', total: 0 },
        { numMonth: '12', month: 'December', total: 0 }
      ],
      profile: null,
      shopId: null,
      shopname: null,
      rewardHistory: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.loading = true
    try {
      this.shopId = this.GET_SHOPID()
      this.profile = this.getLiffProfile()
      if (this.$route.query.shopId) {
        if (typeof this.$session.getAll().shopId === 'undefined') {
          this.$session.remove('shopId')
          this.$session.start()
          this.$session.set('shopId', this.$route.query.shopId)
        }
      }
      if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
        this.getBookingView()
      }
      await this.getPackage()
      await this.prepareData()
      await this.getExpireDate()
      await this.calculateExchangeAmount()
      // await this.getPackLog()
      if (this.$route.query.openHistory) {
        await this.getHistory()
      }
      try {
        if (this.member && this.member.collectPoint != null && this.nextlevel && this.nextlevel.point != null) {
          this.calMoney(this.point, this.member.collectPoint, 400, this.nextlevel.point).then(result => {
            this.moneyResult = result
          })
        }
      } catch (err) {
        // ไม่ log error
      }
      // ไม่ log error
      if (this.member && this.member.levelId) {
        await this.getLevelById()
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    } catch (err) {
      console.error(err)
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    ...mapActions('memberStore', ['getMemberProfile']),
    async calMoney (point, member, exchangeRate, maxTotal) {
      try {
        if (point) {
          if (this.level.pointPersen) {
            let totalPoint = point - member
            let mainPoint = totalPoint * exchangeRate // 955600
            // let persenData = (parseInt(this.level.pointPersen) + 100) / 100
            let deffPoint = mainPoint
            // let deffPoint = mainPoint - (mainPoint * (parseInt(this.level.pointPersen) / 100))
            return this.formatNumber(Math.round(deffPoint))
          } else {
            let totalPoint = (point - member) * exchangeRate
            return this.formatNumber(totalPoint)
          }
        } else {
          return 0
        }
      } catch (error) {
        console.error(error)
      }
    },
    calculateExchangeAmount (pointsReceived, totalPoints, exchangeRate) {
      // console.log('this.member::===>>', this.member)
      if (exchangeRate <= 0) {
        throw new Error('อัตราแลกเปลี่ยนต้องมากกว่า 0')
      }

      return {
        exchangeableAmount: pointsReceived / exchangeRate,
        totalAmount: totalPoints / exchangeRate
      }
    },
    copyText () {
      let textToCopy = this.$refs.textToCopy[0].$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    async getBookingView () {
      try {
        const response = await axios.get(`${this.DNS_Link}/booking_view/get`, {
          params: {
            shopId: this.shopId,
            userId: this.profile.userId
          }
        })

        if (!response.data) {
          throw new Error('No response data')
        }

        if (!Array.isArray(response.data)) {
          this.noDataMessage = response.data.message || 'No data available'
          this.allDataLoaded = true
          return
        }

        const bookings = response.data
        const statusMapping = {
          confirm: { status: 'ยืนยัน', color: '#4CAF50' },
          // eslint-disable-next-line camelcase
          confirmJob: (RECORD_STATUS_Job) => {
            // eslint-disable-next-line camelcase
            if (RECORD_STATUS_Job === 'N') {
              return { status: 'ยังไม่ปิดงาน', color: '#2196F3' }
              // eslint-disable-next-line camelcase
            } else {
              return { status: 'จบงาน', color: '#3F51B5' }
            }
          },
          cancel: { status: 'ยกเลิก', color: '#F44336' },
          default: { status: 'รอยืนยัน', color: '#FFB74D' }
        }

        const newBookings = bookings.map(item => {
          // eslint-disable-next-line camelcase
          const { statusBt, RECORD_STATUS_Job, flowName, dueDateTextDay, timeText, masBranchName, bookingDataCustomerName, bookingDataCustomerTel, remark, depositImge, hangoutLink } = item
          // const { status, color } = statusMapping[statusBt] || statusMapping.default
          let status, color
          if (statusBt === 'confirmJob') {
            ({ status, color } = statusMapping.confirmJob(RECORD_STATUS_Job))
          } else {
            ({ status, color } = statusMapping[statusBt] || statusMapping.default)
          }
          // console.log(item)
          return {
            status,
            color,
            title: flowName,
            day: this.convertDate(dueDateTextDay),
            time: timeText,
            branch: masBranchName,
            name: bookingDataCustomerName,
            phone: bookingDataCustomerTel,
            note: remark,
            linkMeet: hangoutLink,
            link: depositImge
          }
        })

        this.allBookings = newBookings
        this.displayedBookings = this.allBookings.slice(0, this.currentPage * this.itemsPerPage)

        if (newBookings.length < this.itemsPerPage) {
          this.allDataLoaded = true
        }
      } catch (error) {
        console.error('Error fetching booking view:', error.message)
      }
    },
    convertDate (dateString) {
      const buddhistYearFormat = 'DD MMM YYYY'
      const date = moment(dateString, 'DD/MM/YYYY').locale('th')
      return date.format(buddhistYearFormat).replace(/(\d{4})/, (match) => (parseInt(match) + 543))
    },
    // formatPhoneNumber (phoneNumber) {
    //   try {
    //     // Remove any non-digit characters
    //     const digits = phoneNumber.replace(/\D/g, '')
    //     // Split the digits into the desired format
    //     const formattedNumber = ${digits.slice(0, 3)} ${digits.slice(3)}

    //     return formattedNumber
    //   } catch (error) {
    //     console.log(error)
    //     console.log(phoneNumber)
    //     return phoneNumber || '-'
    //   }
    // },
    async prepareData () {
      try {
        this.member = this.GET_MEMBERINFO()
        if (!this.member) {
          console.warn('Member info not available')
          return
        }
        // console.log('this.member', this.member)

        this.checkTerm1 = this.member.CONDITION_TERM1
        this.checkTerm2 = this.member.CONDITION_TERM2
        if (this.checkTerm1 !== null) {
          this.checkTerm1 = (this.member.CONDITION_TERM1.toLowerCase() === 'true')
        }
        if (this.checkTerm2 !== null) {
          this.checkTerm2 = (this.member.CONDITION_TERM2.toLowerCase() === 'true')
        }
        // console.log('this.checkTerm2', this.checkTerm2)
        await this.getOnlyShop()
        // console.log('his.checkTerm1', this.checkTerm1)
        await this.getLevelDB()
        // console.log('cardLevel', this.level)
        // console.log('this.member', this.member)
        // await this.getMyReward()
        this.level.sort((a, b) => {
          return b.point - a.point
        })
        let dataLevel = this.level.findIndex(item => parseInt(item.levelId) === parseInt(this.member.levelId))
        if (this.level.length > dataLevel) {
          dataLevel -= 1
        }
        this.nextlevel = this.level[dataLevel]
        // this.level.map((row) => {
        //   if (this.member.collectPoint < row.point) {
        //     this.nextlevel = row
        //   }
        // })
        // console.log('nextlevel', this.nextlevel)
        if (this.nextlevel) {
          this.point = this.nextlevel.point
        } else {
          // console.log('test11111', this.point)
        }
        this.level = this.level.filter(
          (item) => parseInt(item.levelId) === parseInt(this.member.levelId)
        )[0]
        if (this.nextlevel && this.member.collectPoint > 0) {
          this.valueInprogress = (
            (this.member.collectPoint * 100) /
            this.nextlevel.point
          ).toFixed(2)
        }
      } catch (error) {
        console.error(error)
      }
    },
    openPrivacyNotice () {
      window.open(window.location.origin + '/PrivacyNotice', '_blank').focus()
    },
    async getHistory () {
      const result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/lineHistory/get?redeemStatus=use'
      )
      if (result) {
        if (Array.isArray(result)) {
          this.rewardHistory = result
        }
      }
      this.dialogRewardhistory = true
    },
    async getMyReward () {
      const result = await this.callBeTaskAPI(
        'get',
        `/rewardCode/line/get?redeemStatus=get`
      )
      if (Array.isArray(result)) {
        this.rewards = result
      }
    },
    async upDatePDPA () {
      // console.log({ CONDITION_TERM1: this.checkTerm1, CONDITION_TERM2: this.checkTerm2 })
      await this.callBeTaskAPI(
        'post',
        `/member/edit/${this.member.memberId}`,
        { CONDITION_TERM1: this.checkTerm1, CONDITION_TERM2: this.checkTerm2 }
      )
      await this.getMemberProfile()
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI(
        'get',
        '/level/line/get?RECORD_STATUS=N'
      )
      if (result) {
        if (result.length > 0) {
          this.level = result
          this.allLevel = result
          return result
        }
      }
    },
    async getLevelById () {
      if (!this.member || !this.member.levelId) {
        return null
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )

      if (result) {
        this.levelById = result
        return result
      }
    },
    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.shopname = result[0].name
        }
      }
    },
    async getExpireDate () {
      const d = new Date()
      let ThisYear = d.getFullYear()
      let Nextyear = d.getFullYear() + 1
      const result2 = []
      const result3 = []
      const result = await this.callBeTaskAPI(
        'get',
        `/get-expired-date/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.expire = result.map((item) => {
          return {
            expire: moment.unix(item.expireDate).format('MM/YYYY'),
            balanceExpire: item.balancePoint,
            year: moment.unix(item.expireDate).format('YYYY')
          }
        }).filter((item) => { return item.year === ThisYear.toString() })

        this.expire1 = result.map((item) => {
          return {
            expire: moment.unix(item.expireDate).format('MM/YYYY'),
            balanceExpire: item.balancePoint,
            year: moment.unix(item.expireDate).format('YYYY')
          }
        }).filter((item) => { return item.year === Nextyear.toString() })
      }
      if (this.expire) {
        this.expire.reduce((res, value) => {
          if (!res[value.expire]) {
            res[value.expire] = {
              month: value.expire.split('/')[0],
              year: value.expire.split('/')[1],
              balanceExpire: 0
            }
            result2.push(res[value.expire])
          }
          res[value.expire].balanceExpire += value.balanceExpire
          return res
        }, {})
      }
      if (this.expire1) {
        this.expire1.reduce((res, value) => {
          if (!res[value.expire]) {
            res[value.expire] = {
              month: value.expire.split('/')[0],
              year: value.expire.split('/')[1],
              balanceExpire: 0
            }
            result3.push(res[value.expire])
          }
          res[value.expire].balanceExpire += value.balanceExpire
          return res
        }, {})
      }
      this.AllExpireCoinThisYear = result2.reduce((accum, obj) => accum + obj.balanceExpire, 0)
      this.AllExpireCoinNextYear = result3.reduce((accum, obj) => accum + obj.balanceExpire, 0)
      for (const element of this.month) {
        for (const a of result2) {
          if (element.numMonth === a.month) {
            element.total = a.balanceExpire
          }
        }
      }
      for (const element of this.month1) {
        for (const a of result3) {
          if (element.numMonth === a.month) {
            element.total = a.balanceExpire
          }
        }
      }
    },
    async getPackLog () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/get?userId=${this.profile.userId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackage = true
      }
    },
    async getPackage () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/getCount?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackageCount = result[0].count
      }
    },
    checkpushCustom () {
      return this.$isTargetShop()
    },
    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    },
    HEXToVBColorLMGCard (hex) {
      // รองรับ #B3B3B3, #B3B3B3FF, #FFA300, #FFA300FF, #E6A405, #E6A405FF
      const isSpecialColor = (
        hex === '#484848FF' ||
        hex === '#000ECCFF' ||
        hex === '#808080FF' ||
        /^#B3B3B3([A-Fa-f0-9]{0,2})$/.test(hex) ||
        /^#FFA300([A-Fa-f0-9]{0,2})$/.test(hex) ||
        /^#E6A405([A-Fa-f0-9]{0,2})$/.test(hex)
      )
      return this.$isTargetShop() && isSpecialColor
        ? '#fff'
        : this.$CUSTOMMainTextColor
    }
  }
}
</script>
<style scoped>
.menu-card {
  display: flex;
  flex-direction: column;
  flex-basis: calc(50% - 5px);
  max-width: calc(50% - 5px);
  padding: 10px;
  border-radius: 10px;
  height: auto;
}

.card {
  height: 200px;
  overflow: hidden;
}

.cardbg {
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}

.v-progress-linear {
  width: 90%;
}

.test {
  padding-left: 20px;
}

html,
body {
  width: 100%;
  overflow-x: hidden;
  background-color: #fff !important;
      height: -webkit-fill-available;
}
main {
  background-color: #fff !important;
      height: -webkit-fill-available;
}

.text-gradient {
  background: linear-gradient(to right, #000000, #52057B, #892CDC, #BC6FF1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.v-input--hide-details>.v-input__control>.v-input__slot {
  margin-bottom: 15px;
}

.text-bold-mb-10 {
  margin-bottom: 10px;
  color: var(--color-text);
}
.text-bold-mb-10.bold {
  font-weight: bold;
}
.iconWhite {
filter: brightness(0) invert(1);
  /* transition: .2s; */
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/Main.vue